import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var VehicleImgDeleteRes;
export const VehicleImgDeleteTodo = createAsyncThunk('VehicleImgDelete', async (id) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Delete",
            url: process.env.REACT_APP_API_URL + `delete_vehicle_photo/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return VehicleImgDeleteRes = res.data

    } catch (error) {
        return VehicleImgDeleteRes = error.response.data
    }
})
